__turbopack_context__.v({
  "card": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__card",
  "cardReadOnly": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__cardReadOnly",
  "cardSelected": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__cardSelected",
  "copy": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__copy",
  "grid": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__grid",
  "image": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__image",
  "subtitle": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__subtitle",
  "title": "RepairRequestShippingKitSelector-module-scss-module__2OL65G__title",
});
